<template>
  <div class="content">
    <!-- <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Paginated Tables</h2>
    </div> -->
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Funcionários Demitidos/Suspensos
          </h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar funcionário"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <!-- <base-button
                    @click.native="handleLike(props.$index, props.row)"
                    class="like btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-heart-2"></i>
                  </base-button> -->

                  <el-tooltip
                    content="Readmitir ou Reativar Funcionário"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="handleReadimitir(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-check-2"></i>
                    </base-button>
                  </el-tooltip>
                  <!-- <base-button
                    @click.native="handleDelete(props.$index, props.row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button> -->
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} funcionários.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      dadosUsuario: "",
      selectRow: [],
      horarioSelecionado: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["nome", "motivo"],
      tableColumns: [
        {
          prop: "nome",
          label: "Funcionário",
          minWidth: 200,
        },
        {
          prop: "motivo",
          label: "Motivo",
          minWidth: 250,
        },
        {
          prop: "data_demissao",
          label: "Data da demissão",
          minWidth: 100,
        },
        // {
        //   prop: "salary",
        //   label: "Salary",
        //   minWidth: 120
        // }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarFuncionariosDemitidos();
  },
  methods: {
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    carregarFuse() {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["nome", "motivo"],
        threshold: 0.3,
      });
    },

    showAlert(param) {
      if (param == "readimitir_funcionario") {
        swal({
          title: "Tem certeza?",
          text: `Deseja realmente readmitir ou reativar o funcionário?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim",
          cancelButtonText: "Não!",
          buttonsStyling: false,
        })
          .then((response) => {
            if (response.value) {
              this.readimitirFuncionario();
            }
          })
          .catch((err) => {});
      }
    },

    handleReadimitir(index, row) {
      this.selectRow = row;
      this.showAlert("readimitir_funcionario");
    },

    listarFuncionariosDemitidos() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregadosDemitidos", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.tableData = response.data.data.dados;
          th.carregarFuse();
        })
        .catch((err) => {
          th.isLoading = false;
        });
    },

    readimitirFuncionario() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_demissao: this.selectRow.id_demissao,
      };
      this.axios
        .post("/api/empregado/readmitirEmpregado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Funcionário readmitido com sucesso!",
            "success",
          );
          setTimeout(() => {
            location.reload();
          }, 2000);
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao readimitir funcionário!",
            "error",
          );
        });
    },
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
